export default __webpack_public_path__ + "locales/it/ChangeUserTypeDialog.json?hash=22f422b7e3673bbea71e24603915c367";